import Swal from "sweetalert2";

export function useSwal() {
    return Swal;
}
